import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Message, Icon } from 'semantic-ui-react';
import moment from 'moment';
import ReactTable from 'react-table';

import { TitledCard } from 'Components/';
import { Main } from 'Containers/';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { getUnclosedDates } from '../state/actions';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';

class UnclosedDates extends Component {
  static propTypes = {
    nextStep: PropTypes.func.isRequired,
    isComplete: PropTypes.bool.isRequired,
    fiscalYear: PropTypes.number.isRequired,
  };

  state = {
    loadingUnclosedDates: false,
  };

  componentDidMount() {
    // If we don't have any unclosedDates, load them.
    if (!this.props.unclosedDates) {
      this.getUnclosedDates();
    }
  }

  getUnclosedDates = async () => {
    const { getUnclosedDates } = this.props;
    this.setState({ loadingUnclosedDates: true });

    const pr = getUnclosedDates();
    const timer = new Promise(resolve => setTimeout(resolve, 3000));

    await Promise.all([pr, timer]);

    this.setState({ loadingUnclosedDates: false });
  };

  getMainProps = () => {
    const {
      isComplete,
      nextStep,
      unclosedDates,
      setYesNoDialogProps,
      fiscalYear,
    } = this.props;

    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Next',
            onClick: () => {
              // If this step has already been completed or there aren't any unclosded dates go to the next step.
              if (isComplete || unclosedDates.length === 0) {
                return nextStep();
              }

              if (unclosedDates.length) {
                setYesNoDialogProps({
                  showDialog: true,
                  title: 'Continue',
                  question: `There are ${
                    unclosedDates.length
                  } unclosed dates for fiscal year ${fiscalYear}, continue closing the school year?`,
                  yesCallback: nextStep,
                  noCallback: () => {},
                  cancelCallback: () => {},
                });
              }
            },
            disabled: unclosedDates === null || this.state.loadingUnclosedDates,
          },
        ],
        shown: true,
      },
    };
  };

  render() {
    return (
      <Main {...this.getMainProps()}>
        <TitledCard title={'Unclosed Dates'}>{this.getContent()}</TitledCard>
      </Main>
    );
  }

  getContent = () => {
    const { fiscalYear, unclosedDates } = this.props;
    const { loadingUnclosedDates } = this.state;

    if (!unclosedDates || loadingUnclosedDates) {
      return (
        <Message icon>
          <Icon name="spinner" loading />
          <Message.Content>
            <Message.Header>Just a second..</Message.Header>
            We are looking for unclosed dates.
          </Message.Content>
        </Message>
      );
    }

    return unclosedDates.length > 0 ? (
      <React.Fragment>
        <Message>
          <Message.Content>
            <Message.Header>
              {`We found ${
                unclosedDates.length
              } unclosed dates for fiscal year ${fiscalYear}`}
            </Message.Header>
          </Message.Content>
        </Message>
        <ReactTable
          columns={[
            { Header: 'Site Id', accessor: 'ID' },
            {
              Header: 'Site Name',
              accessor: 'Description',
            },
            {
              Header: 'Date',
              accessor: 'ClosingDate',
              Cell: props => (
                <div>{moment(props.value).format(DATE_FORMAT_FOR_UI)}</div>
              ),
            },
            { Header: 'Point of Sale, POS+, or Both', accessor: 'Type' },
            { Header: 'Closed Status', accessor: 'ClosedStatus' },
          ]}
          defaultSorted={[
            {
              id: 'ID',
            },
            {
              id: 'ClosingDate',
              desc: true,
            },
          ]}
          minRows="5"
          data={unclosedDates}
        />
      </React.Fragment>
    ) : (
      <Message success>
        <Message.Content>
          <Message.Header>
            We didn't find any unclosed dates for fiscal year {fiscalYear}
          </Message.Header>
          You can go to the next step.
        </Message.Content>
      </Message>
    );
  };
}

const mapDispatchToProps = {
  setYesNoDialogProps,
  getUnclosedDates,
};

const mapStateToProps = state => {
  const {
    CloseSchoolYear: { unclosedDates },
  } = state;

  return {
    unclosedDates,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnclosedDates);



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/components/UnclosedDates.js